import { lazy } from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
const Layout = lazy(() => import("../Layout"));

const Home = lazy(() => import("../pages/Home"));
const Community = lazy(() => import("../pages/Community"));
const Race = lazy(() => import("../pages/Race"));
const Payment = lazy(() => import("../pages/Payment"));
const User = lazy(() => import("../pages/User"));
const RaceDetails = lazy(() => import("../pages/Race/RaceDetails"));
const RegistrationReports = lazy(() => import("../pages/Reports/RegistrationReports"));
const DonationReports = lazy(() => import("../pages/Reports/DonationReports"));
const VolunteerReports = lazy(() => import("../pages/Reports/VolunteerReports"));
const TshirtsReports = lazy(() => import("../pages/Reports/TshirtsReports"));
const FundRaisingReports = lazy(() => import("../pages/Reports/FundRaisingReports"));
const AddOnReports = lazy(() => import("../pages/Reports/AddOnReports"));
const TeamDetailsTabs = lazy(() => import("../pages/Race/RaceDetails/TeamDetails/TeamDetailsTabs"));
const AuditList = lazy(() => import("../pages/AuditList"));
const ServerSettings = lazy(() => import("../pages/ServerSettings"));
const AIChat = lazy(() => import("../pages/AIChat"));

// Route guard: only allows access if user.super_admin === true
const SuperAdminRoute = ({ children }: { children: React.ReactElement }) => {
  const isSuperAdmin = useSelector((state: any) => {
    return state?.adminLoginSlice?.superAdmin === true;
  });

  if (!isSuperAdmin) {
    return <Navigate to="/home" replace />;
  }

  return children;
};


const PrivateRoutes = () => {
  const allPrivateRoutes = useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Navigate replace to="home" />,
        },
        {
          path: "home",
          element: <Home />,
        },
        {
          path: "user",
          element: <User />,
        },
        {
          path: "community",
          element: <Community />,
        },
        {
          path: "race",
          element: <Outlet />,
          children: [
            {
              path: "",
              element: <Race />,
            },
            {
              path: ":race_id",
              element: <Outlet />,

              children: [
                {
                  path: "",
                  element: <RaceDetails />,
                },
                {
                  path: "team-details/:slug",
                  element: <TeamDetailsTabs />,
                },
              ],
            },
          ],
        },

        {
          path: "reports",
          element: <Outlet />,
          children: [
            {
              path: "/reports/registration-reports",
              element: <RegistrationReports />,
            },
            {
              path: "/reports/donation-reports",
              element: <DonationReports />,
            },
            {
              path: "/reports/volunteer-reports",
              element: <VolunteerReports />,
            },
            {
              path: "/reports/t-shirt-reports",
              element: <TshirtsReports />,
            },
            {
              path: "/reports/fund-raising-reports",
              element: <FundRaisingReports />,
            },
            {
              path: "/reports/add-on-reports",
              element: <AddOnReports />,
            },
          ],
        },
        {
          path: "payment", // todo: add transactions feature here
          element: <Payment />,
        },
        {
          path: "audit-list",
          element: <AuditList />,
        },
        {
          path: "ai-chat",
          element: <AIChat />,
        },
        {
          path: "server-settings",
          element: (
            <SuperAdminRoute>
              <ServerSettings />
            </SuperAdminRoute>
          ),
        },
        {
          path: "*",
          element: <Navigate to="/home" />,
        },
      ],
    },
  ]);
  return allPrivateRoutes;
};

export default PrivateRoutes;
